import React from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import RocketIcon from "./RocketIcon";
import { useLanguage } from "../contexts/LanguageContext";

export default function Logo({
  to = "/",
  size = 28,
  variant = "full",
  tone = "default",
  className = "",
  testId = "brand-logo",
  uniqueId = "logo",
  onClick,
}) {
  const { lang } = useLanguage();
  const navigate = useNavigate();
  const location = useLocation();
  const compact = variant === "compact";

  const wordmark = compact ? "ym" : lang === "tr" ? "yastıkmedya" : "PillowMedia";
  const lowercaseClass = lang === "tr" ? "lowercase" : "normal-case";

  const wordClass = tone === "cream" ? "text-cream" : "text-ink";
  const accentClass = "gold-foil-text";

  const handleClick = (e) => {
    if (onClick) onClick(e);
    // Always scroll to top
    window.scrollTo({ top: 0, behavior: "smooth" });
    // If already on the target page, prevent navigation but still scroll
    if (location.pathname === to || location.pathname === `${to}/`) {
      e.preventDefault();
    }
  };

  return (
    <Link
      to={to}
      onClick={handleClick}
      data-testid={testId}
      className={`group inline-flex items-center gap-2.5 select-none ${className}`}
      aria-label="Yastık Medya"
    >
      <RocketIcon size={size} id={uniqueId} className="-rotate-[15deg]" />
      {compact ? (
        <span
          className={`font-display font-extrabold lowercase leading-none ${accentClass}`}
          style={{ fontSize: `${size * 0.78}px`, letterSpacing: "-0.05em" }}
        >
          ym
        </span>
      ) : (
        <span
          className={`font-display font-extrabold leading-none ${lowercaseClass}`}
          style={{ fontSize: `${size * 0.82}px`, letterSpacing: "-0.04em" }}
        >
          <span className={accentClass}>#</span>
          <span className={wordClass}>{wordmark}</span>
        </span>
      )}
    </Link>
  );
}
